import { Suspense } from 'react';
import RoleForm from '../../components/RoleForm';
import Wrapper from '~/App/components/Wrapper';
import Header from '~/App/components/Header';
import ErrorBoundary from '~/App/components/ErrorBoundary';
import Loading from '~/App/components/Loading';
import { useMutation } from '@tanstack/react-query';
import message from '~/utils/message';
import api from '../../api';
import { useNavigate } from 'react-router-dom';

const CreateRole = () => {
  const navigate = useNavigate();
  const { isPending, mutate } = useMutation({
    mutationFn: api.createRole,
    retry: false,
    onSuccess: () => {
      message.success('Success create role');
      navigate('..');
    },
    onError: () => {
      message.error('Fail to create role');
    },
  });

  return (
    <Wrapper>
      <Header title="Create Role" />
      <ErrorBoundary>
        <Suspense fallback={<Loading className="h-[400px]" />}>
          <RoleForm loading={isPending} onSubmit={mutate} />
        </Suspense>
      </ErrorBoundary>
    </Wrapper>
  );
};

export default CreateRole;
